import { Value } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { validatePayload } from '../../../../utils/validate-payload.js';
import { facetIdDefinition } from '../../generic/facet-actions-validation.js';
export const updateRangeFacetSortCriterion = createAction('rangeFacet/updateSortCriterion', (payload) => validatePayload(payload, {
    facetId: facetIdDefinition,
    criterion: new Value({ required: true }),
}));
